<template>
    <!-- 安全演练设置 -->
    <div class="inside_pages_right_top">
        <ul>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/drill_evacuation_map'}"  @click="$Common.pageJump('/drill_evacuation_map',3)">
                演练疏散路线图
            </li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/emergency_rescue_equipment'}" @click="$Common.pageJump('/emergency_rescue_equipment',3)">
                应急救援器材
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name:'SafetyDrillSettings',
    components: {},
    props: {},
    data() {
        return {
        };
    },
    watch: {
    },
    computed: {
    },
    methods: {
       
    },
    created() {
    },
    mounted() {
    },
};
</script>
<style scoped>
@import '/css/base.css';
@import '/css/authority.css';
</style>